import { useEffect, useState } from 'react'
import { supabase } from './supabaseClient'

// useOrgSettings — reads organizations.features for a given event so
// components don't have to prop-drill the same query. Returns
//   { features, hideFactionScores, aarFactionReveal, playSheetMode, loading }
//
// Pass an eventId — the hook resolves the event's org_id and fetches
// its features blob. Defaults stay sane (hide off, reveal 7_days,
// play sheet 'limited') when the event or org row is missing.
export default function useOrgSettings(eventId) {
  const [features, setFeatures] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      if (!eventId) { setFeatures({}); setLoading(false); return }
      setLoading(true)
      const { data: ev } = await supabase
        .from('events').select('org_id').eq('id', eventId).limit(1)
      const orgId = ev?.[0]?.org_id
      if (!orgId) { if (!cancelled) { setFeatures({}); setLoading(false) }; return }
      const { data: org } = await supabase
        .from('organizations').select('features').eq('id', orgId).limit(1)
      if (cancelled) return
      setFeatures(org?.[0]?.features || {})
      setLoading(false)
    }
    load()
    return () => { cancelled = true }
  }, [eventId])

  return {
    features,
    hideFactionScores:  !!features.hide_faction_scores,
    aarFactionReveal:   features.aar_faction_reveal || '7_days',
    playSheetMode:      features.play_sheet_mode || 'limited',
    loading,
  }
}
